/* eslint-disable */
import { useEffect, useRef } from 'react'
import scrollEventFn from '../scroll_event'
export default function Outline(){
  // scroll event
  const scroll01 = useRef(null)
  const scroll02 = useRef(null)
  const scrollArr = [
    scroll01,
    scroll02,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <div className="contents">
      <div className="content-title02">손해사정 개요</div>
      <div className="outlineBox">
        <div className="outlineImg">
          <div className="outlineImgBox left" style={{backgroundImage:'url(/img/outline_01.png)'}}></div>
        </div>
        <div className="outlineTxt">
          <div className="outlineTxtBox scrollBox" ref={scroll01}>
            <div className="outlineTitle">손해사정 개요</div><br/>
            손해사정이란 발생한 보험사고의 원인과 피해내용, 그리고 손해의 내용과 정도, 범위에 대하여 확인하고, 보험의 목적에 해당되는지 여부와 손해액을 평가, 결정하고 
            보험금을 지급하는 업무를 총칭합니다. 손해사정업무는 보험사고의 접수, 계약사항 확인, 현장조사, 손해액 조사, 보험약관 관계법규 적용에 의한 면부책 판단, 보험금의 계산, 보험금 지급 후의 절차 등으로서 검증과 정산을 하는 업무를 말합니다.
          </div>
        </div>
      </div>
      <div className="outlineBox">
        <div className="outlineTxt">
          <div className="outlineTxtBox outlineTxtBox02 scrollBox" ref={scroll02}>
            <div className="outlineTitle">손해사정 도입 목적</div><br/>
            손해사정제도는 보험사고 발생 시 손해액 및 보험금의 사정이 보험사업자에 의하여만 이루어질 경우 보험계약자, 피보험자, 보험수익자나 피해자 등의 권익이 침해될 수 있다는 우려에서 손해사정이라는 중립적인 위치에 있는 전문자격자가 사고원인과 피해내용 및 그로 인한 손해의 내용과 정도, 범위 등에 대하여 조사, 확인하는 손해사정업무를 담당하게 함으로써 객관적이고 공정하며 합리적인 보험금을 산출하기 위해 도입되었습니다.
          </div>
        </div>
        <div className="outlineImg">
          <div className="outlineImgBox right" style={{backgroundImage:'url(/img/outline_02.png)'}}></div>
        </div>
      </div>
    </div>
  )
}